import * as React from 'react';

/**
 * **等这么久**才让占位骨架脉动起来。
 *
 * 脉动是给「等得久到静止的占位看着像坏了」用的（冷启动等引擎、慢网上的大图）。而热路径上这段
 * 窗口往往只有几十到两百毫秒（一次命令往返；缓存命中时首帧就是内容，压根不经过占位），那么短
 * 的时间里起一段动画，本身就是一次闪。
 */
const PULSE_AFTER_MS = 300;

/**
 * 占位骨架**此刻是否该脉动**：等待持续超过 {@link PULSE_AFTER_MS} 才为真，等待一结束立刻归假。
 *
 * `awaiting` 必须是**会落定的**（拿到内容、或问出「确实没有」都算落定），否则这里就成了一个永远
 * 脉动的占位。
 */
export function useSkeletonPulse(awaiting: boolean): boolean {
  const [armed, setArmed] = React.useState(false);
  if (!awaiting && armed) {
    // 渲染期就地收（React 认的用法）：这一位下次再等图时不该一开始就带着动画。
    setArmed(false);
  }
  React.useEffect(() => {
    if (!awaiting) {
      return;
    }
    const timer = window.setTimeout(() => {
      setArmed(true);
    }, PULSE_AFTER_MS);
    return () => {
      window.clearTimeout(timer);
    };
  }, [awaiting]);
  return awaiting && armed;
}
